import styled from "styled-components";
import rewardsDropdownWepbImage from "../../../assets/images/general/rewards-dropdown.webp";
import rewardsDropdownImage from "../../../assets/images/general/rewards-dropdown.png";
import rewardIcon from "../../../assets/images/icons/rewards-transparent.svg";
import Image from "../../atoms/Image";
import { ColumnTitleIcon, DropdownContentWrapper } from "../../organisms/Header/style";

export const DropdownWrapper = styled.div<{ isAnyDropdownActive: boolean }>`
  display: ${(props) => (props.isAnyDropdownActive ? "flex" : "none")};
  height: 100%;
  flex-direction: row;
`;

/* The shared dropdown content wrapper is `height: 0` so most menus stay pinned
 * to the 280px hero-image height. The logged-in rewards menu now lists five
 * items in a single column, which is taller than 280px, so on wide (>1699px)
 * viewports the last item ("Earn Points") was clipped by the panel's overflow.
 * Letting this one wrapper size to its content lets the panel grow to fit the
 * whole list. The shared wrapper's large bottom padding (50px) plus the
 * column's trailing 16px item margin would then leave an airy gap under the
 * last item, so trim both to keep the panel hugging the list. */
export const RewardsDropdownContentWrapper = styled(DropdownContentWrapper)`
  height: auto;
  padding-bottom: 24px;

  a:last-of-type {
    margin-bottom: 0;
  }
`;

/* `align-self: stretch` (rather than a fixed height) makes the image fill the
 * panel's content-driven height, so it reaches the bottom of the menu once the
 * logged-in list grows the dropdown past the 280px hero height instead of
 * leaving a gap below it. `object-fit: cover` keeps it from distorting. */
export const DropdownImage = styled(Image).attrs(() => ({
  src: rewardsDropdownImage,
  webpSrc: rewardsDropdownWepbImage,
  containerStyle: { display: "contents" },
}))`
  max-width: 30%;
  object-fit: cover;
  align-self: stretch;
`;

export const Icon = styled(ColumnTitleIcon).attrs(() => ({ src: rewardIcon }))`
  height: 100%;
`;
